module.exports = "https://static.wanderu.com/static/media/phone-with-qr2x.035bb740.png";